import { Device } from "../../../features/VirtualKoteach";
import LogMessages from "../../../shared/ui/LogMessages";
import InfoBar from "../../../shared/ui/InfoBar/InfoBar";
import AnimationFrame from "../../../shared/ui/AnimationFrame/AnimationFrame";

import "./VktLogListWidget.scss";

const VktLogListWidget = () => {
  return (
    <div className="log_list">
      <div className="log_list__header">
        <AnimationFrame />
        <Device />
      </div>
      <InfoBar />
      <LogMessages />
    </div>
  );
};

export default VktLogListWidget;
